module.exports = __webpack_public_path__ + "img/3-(7).85e82001.jpg";